








































import { Component } from '@niknevis/vue-modules'
import { AdminGetChangelogUseCase } from '@/modules/changelog/use-cases/admin/admin-get-changelog.use-case'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import QTable from 'quasar/src/components/table/QTable.js';
import AdminChangelogRow from '@/modules/changelog/components/admin/AdminChangelogRow.vue'
import AdminChangelogInnerTable from '@/modules/changelog/components/admin/AdminChangelogInnerTable.vue'
import { Prop } from 'vue-property-decorator'
import Pagination from '@/modules/shared/components/shared/pagination/Pagination.vue'
import Vue from 'vue'

@Component({
  components: {
    TesTable,
    AdminChangelogRow,
    AdminChangelogInnerTable,
    Pagination
  }
})
export default class AdminChangelogTable extends Vue {
  constructor(
    private readonly useCase: AdminGetChangelogUseCase
  ) {
    super()
  }

  @Prop({ required: true }) modelId!: number
  @Prop({ required: true }) modelType!: string

  private readonly columns: QTable['columns'] = [
    {
      name: 'created_at',
      field: 'created_at',
      label: 'زمان',
      align: 'left'
    },
    {
      name: 'user',
      field: 'user',
      label: 'کاربر',
      align: 'left'
    },
    {
      name: 'properties',
      field: 'properties',
      label: 'جزئیات',
      align: 'left'
    }
  ]

  goto(page: number) {
    if (this.useCase.getMeta.current_page !== page) {
      this.useCase.execute(this.modelId, this.modelType, page)
    }
  }

  beforeMount() {
    this.goto(1)
  }
}
